import { computed } from 'vue';

import { ShopDetails } from '~model';
import store from '~store';

export default function isPostalAddressRequired(
  shop: ShopDetails,
): boolean {
  const getters = store?.getters;
  const form = computed(() => getters?.getCustomerForm);

  return (
    shop?.codeTypes?.includes('CODE_TYPE_PHYSICAL') ||
    form.value.orderPrepaidVouchers === true
  );
}
